// extracted by mini-css-extract-plugin
module.exports = {"subPrice":"F1A+9XDIJa7M0gwPm0pu2w=="};